export const ELEMENT_IDS = {
  NEXT: 'button_ad_campaign_stepper_media_next',
  BACK: 'button_ad_campaign_stepper_media_back',
  UPLOADER: 'media_uploader_ad_campaign_stepper',
};
